import { call, put, takeEvery } from "redux-saga/effects"
import Swal from "sweetalert2"

// Crypto Redux States
import {
  GET_GOOD_SERVICES_HEAD_MASTER_LIST,
  GET_GOOD_SERVICES_HEAD_MASTER_DETAIL,
  ADD_NEW_GOOD_SERVICES_HEAD_MASTER,
  UPDATE_GOOD_SERVICES_HEAD_MASTER,
  DELETE_GOOD_SERVICES_HEAD_MASTER,
} from "./actionTypes"
import {
  getGoodServicesHeadMasterListSuccess,
  getGoodServicesHeadMasterListFail,
  getGoodServicesHeadMasterDetailSuccess,
  getGoodServicesHeadMasterDetailFail,
  addNewGoodServicesHeadMasterSuccess,
  addNewGoodServicesHeadMasterFail,
  updateGoodServicesHeadMasterSuccess,
  updateGoodServicesHeadMasterFail,
  deleteGoodServicesHeadMasterSuccess,
  deleteGoodServicesHeadMasterFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getGoodServicesHeadMasterList,
  getGoodServicesHeadMasterDetail,
  addNewGoodServicesHeadMaster,
  updateGoodServicesHeadMaster,
  deleteGoodServicesHeadMaster,
} from "helpers/fakebackend_helper"

function* fetchGoodServicesHeadMasterList() {
  try {
    const response = yield call(getGoodServicesHeadMasterList)
    yield put(getGoodServicesHeadMasterListSuccess(response))
  } catch (error) {
    yield put(getGoodServicesHeadMasterListFail(error))
  }
}

function* fetchGoodServicesHeadMasterDetail({ goodServicesHeadId }) {
  try {
    const response = yield call(getGoodServicesHeadMasterDetail, goodServicesHeadId)
    yield put(getGoodServicesHeadMasterDetailSuccess(response))
  } catch (error) {
    yield put(getGoodServicesHeadMasterDetailFail(error))
  }
}

function* onAddNewGoodServicesHeadMaster({ payload: { goodServicesHead, history } }) {
  try {
    const response = yield call(addNewGoodServicesHeadMaster, goodServicesHead)
    if (response.status === true) {
      yield put(addNewGoodServicesHeadMasterSuccess(response))
      Swal.fire({
        title: "Success",
        icon: "success",
        text: "Your Goods Services Head Master Has Been Created.",
      }).then(result => {
        if (result.isConfirmed) {
          history("/settings/goods-services-head-master")
        }
      })
    } else {
      throw new Error(
        response && response.message ? response.message : "Unknown error"
      )
    }
  } catch (error) {
    yield put(addNewGoodServicesHeadMasterFail(error))
    Swal.fire({
      title: "failure",
      icon: "error",
      text: error.message || "Unknown error",
    })
  }
}

function* onUpdateGoodServicesHeadMaster({ payload: { id, goodServicesHead, history } }) {
  try {
    const response = yield call(updateGoodServicesHeadMaster, id, goodServicesHead)
    if (response && response.status === true) {
      yield put(updateGoodServicesHeadMasterSuccess(response))
      Swal.fire({
        title: "Success",
        icon: "success",
        text: "Your Sevice Head  Master Has Been Updated.",
      }).then(result => {
        if (result.isConfirmed) {
          history("/settings/goods-services-head-master")
        }
      })
    } else {
      throw new Error(
        response && response.message ? response.message : "Unknown error"
      )
    }
  } catch (error) {
    yield put(updateGoodServicesHeadMasterFail(error))
    Swal.fire({
      title: "Failure",
      icon: "error",
      text: error.message || "Unknown error",
    })
  }
}

function* onDeleteGoodServicesHeadMaster({ payload: goodServicesHead }) {
  try {
    const response = yield call(deleteGoodServicesHeadMaster, goodServicesHead)
    const response2 = yield put(deleteGoodServicesHeadMasterSuccess(response))
    // yield put(deleteSACHSNCodeSuccess(response))
    if (response2.payload.status) {
      const goodServicesHeadMasterListResponse = yield call(getGoodServicesHeadMasterList)
      yield put(getGoodServicesHeadMasterListSuccess(goodServicesHeadMasterListResponse))
    } else {
      console.error("Error in delete GoodServicesHead Master:", response.error)
    }
  } catch (error) {
    yield put(deleteGoodServicesHeadMasterFail(error))
  }
}

function* goodServicesHeadMasterSaga() {
  yield takeEvery(GET_GOOD_SERVICES_HEAD_MASTER_LIST, fetchGoodServicesHeadMasterList)
  yield takeEvery(GET_GOOD_SERVICES_HEAD_MASTER_DETAIL, fetchGoodServicesHeadMasterDetail)
  yield takeEvery(ADD_NEW_GOOD_SERVICES_HEAD_MASTER, onAddNewGoodServicesHeadMaster)
  yield takeEvery(UPDATE_GOOD_SERVICES_HEAD_MASTER, onUpdateGoodServicesHeadMaster)
  yield takeEvery(DELETE_GOOD_SERVICES_HEAD_MASTER, onDeleteGoodServicesHeadMaster)
}

export default goodServicesHeadMasterSaga
